import {toggle_loader, disable_loader} from '../_loader';
import apply_fulfilment_to_results from './_loop-item';

document.addEventListener("DOMContentLoaded", function () {

    //attempt to find the load more button
    let pagination_load_more = document.getElementById('pagination-load-more');

    //sets whether we should restore pagination on reload
    const restore_pagination = tyres_ajax_object.restore_pagination;

    //sets whether or not we should use infinity scroll
    const infinity_scroll = tyres_ajax_object.infinity_scroll;

    //if we have a load more button
    if(pagination_load_more) {

        //define a loading flag
        let pagination_loading = false;

        //fetch our base offset
        let offset = pagination_load_more.getAttribute('data-base_offset') ?? 0;

        //fetch our target offset
        let target_offset = pagination_load_more.getAttribute('data-offset') ?? 0;

        async function load_more(button) {

            //if we're already loading or the button is already hidden, don't do anything
            if(pagination_loading || button.style.display === 'none') {
                return;
            }

            //set our loading flag
            pagination_loading = true;

            //show the loader
            toggle_loader();

            //define the number of pagination loops
            let loops = 1;

            //if we're restoring pagination and we have a target offset...
            if(restore_pagination && target_offset) {

                //calculate the number of loops
                for(let i = 0; i < 100; i++) {

                    if((offset * i) > target_offset) {
                        break;
                    }

                    loops = i;
                }
            }

            for(let i = 0; i < loops; i++) {

                //refresh the offset
                offset = button.getAttribute('data-base_offset') ?? 0;

                //fetch the current url
                let request_url = location.href.substr(location.href.indexOf(location.host)+location.host.length);

                //find the results container
                let results = document.querySelector('div[data-results]');

                //if the url already contains an offset
                if (request_url.includes('offset')) {

                    //replace the offset with the new one
                    request_url = request_url.replace(/offset=\d+/, `offset=${offset}`);
                } else {

                    let joiner = request_url.includes('?') ? '&' : '?';

                    //append the offset to the url
                    request_url = `${request_url}${joiner}offset=${offset}`;
                }

                // Create a promise to handle the XMLHttpRequest
                await new Promise((resolve, reject) => {
                    const xhr = new XMLHttpRequest();
                    xhr.addEventListener("readystatechange", function () {
                        if (this.readyState === this.DONE) {
                            try {
                                // Parse the response
                                let data = JSON.parse(this.responseText);

                                // Append the new HTML to the container
                                results.innerHTML += data.html;

                                // If we have no more results, hide the button
                                if (data.remaining <= 0) {

                                    // Hide the button
                                    button.style.display = 'none';

                                    //revert the offset in the request URL so we don't end up too far ahead
                                    request_url = request_url.replace(/offset=\d+/, `offset=${data.offset - data.pagination}`);
                                } else {

                                    // Update our offset attribute
                                    button.setAttribute('data-base_offset', data.offset);

                                    // Update the button text
                                    button.innerHTML = 'Load ' + (data.remaining < data.pagination ? data.remaining : data.pagination) + ' More';
                                }

                                //update the URL
                                window.history.replaceState(null, null, request_url);

                                //re-apply our selected fulfilment option
                                apply_fulfilment_to_results();

                                //if this is the last loop
                                if(i === (loops - 1)) {

                                    //hide the loader
                                    disable_loader();

                                    //reset the loading flag
                                    pagination_loading = false;
                                }

                                resolve();
                            } catch (error) {
                                console.log(error);

                                //hide the loader
                                disable_loader();

                                //reset the loading flag
                                pagination_loading = false;

                                reject(error);
                            }
                        }
                    });

                    xhr.open("GET", request_url + '&ajax=true');
                    xhr.setRequestHeader("Accept", "*/*");
                    xhr.setRequestHeader("Content-Type", "application/json");

                    // Delay so the loader has time to show (I know...)
                    setTimeout(() => {
                        xhr.send();
                    }, 150);
                });
            }
        }

        //if we're restoring pagination and we have a target offset...
        if(restore_pagination && target_offset) {

            //load more results automatically
            load_more(pagination_load_more);
        }

        //register a global click handler
        document.addEventListener('click', function (event) {

            //if the clicked element is our pagination button
            if (event.target.id && event.target.id === 'pagination-load-more') {

                //prevent the default action
                event.preventDefault();

                //load more results
                load_more(event.target);

            }
        }, false);

        //if we're using infinity scroll
        if(infinity_scroll) {

            //add a scroll event
            document.addEventListener('scroll', function (event) {

                //if the load more button is in view and keyboard navigation is not occuring...
                if (pagination_load_more.getBoundingClientRect().top < window.innerHeight && !this.body.classList.contains('show-focus-outlines')) {

                    //load more results
                    load_more(pagination_load_more);
                }
            });
        }
    }
});